import { useQuery } from 'react-query';

import { GetDocChronologyDocsResponseDto } from '../../../../backend/src/case/chronology/doc-chronology/dto/get-doc-chron-docs-response.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetDocChronologyDocs = ({
  matterId,
  subsetId,
  docChronologyId,
  page,
  pageSize,
}: {
  matterId: string;
  subsetId: string;
  docChronologyId: string;
  page: number;
  pageSize: number;
}) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<GetDocChronologyDocsResponseDto>(
    [QueryEntity.DocChronologyDocs, { docChronologyId, page, pageSize }],
    async () => {
      return fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/doc-chronology/${docChronologyId}/docs?page=${page}&pageSize=${pageSize}`,
        fetchConfigGET,
      ).then((res) => {
        return res.json();
      });
    },
    { enabled: !!matterId && !!subsetId && !!docChronologyId, keepPreviousData: true },
  );
};
